import React, {ReactElement} from 'react';

const TermsAndCondtion = (): ReactElement => {
  return (
    <div className="w-full px-4 text-left text-small tracking-very_very_tightest">
      <div>
        <div className="text-left flex">
          <span className="font-bold h-4 pr-3">{'\u2022'}</span>
          <p>
            Max Buddy program is rolled out only in select stores of Bangalore.
          </p>
        </div>
        <br />
        <div className="text-left flex">
          <span className="font-bold h-4 pr-3">{'\u2022'}</span>
          <p>
            Max Buddy is a mobile number-based program and mobile number will be
            the sole identifier for customer to avail benefits.
          </p>
        </div>
        <br />
        <div className="text-left flex">
          <span className="font-bold h-4 pr-3">{'\u2022'}</span>

          <p>
            Lifestyle International Pvt Ltd, Max Retail Division may, at its
            sole discretion and without any prior intimation, either add or
            discontinue announced benefits, brands, stores from the program.
          </p>
        </div>
        <br />
        <div className="text-left flex">
          <span className="font-bold h-4 pr-3">{'\u2022'}</span>
          <p>
            All customer related information can be updated through the landmark
            rewards program from time to time by logging into website
            www.landmarkrewards.in or by writing to feedback@landmarkrewards.in
            or calling the toll-free number 1800-208-2444.
          </p>
        </div>
        <br />
        <div className="text-left flex">
          <span className="font-bold h-4 pr-3">{'\u2022'}</span>

          <p>
            Surprise offers will be available to customers at stores through
            scanning QR codes at respective locations where offers are
            available.
          </p>
        </div>
        <br />
        <div className="text-left flex">
          <span className="font-bold h-4 pr-3">{'\u2022'}</span>
          <p>
            Special Brand/Surprise offers will be given at sole discretion of
            Lifestyle International Pvt. Ltd Max Retail Division
          </p>
        </div>
      </div>
    </div>
  );
};
export default TermsAndCondtion;
